// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.challenge-name {
  display: flex;
  justify-content: start;
  padding: 0px 24px;
  column-gap: 8px;
  align-items: center;
}
.challenge-name span {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #757575;
}
.loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.scrollable-content {
  overflow: auto;
  height: 80vh;
}
.action-button-section {
  display: flex;
  justify-content: space-between;
  padding: 12px 24px;
  position: relative;
  z-index: 10;
}
.action-button-section .buttonContainer .MuiButton-root.Mui-disabled {
  background-color: #e0e0e0;
  color: #9e9e9e;
}
.cancel-box,
.add-box {
  display: flex;
  gap: 12px;
  justify-content: center;
}
.add-box
  button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-colorPrimary.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-colorPrimary.button_type_button.btn--primary.dPSButtonComponentSection {
  column-gap: 6px;
}

/* Ensure menu appears above content */
#add-notes-menu {
  z-index: 1300;
}

.MuiMenu-root {
  z-index: 1300 !important;
}

.MuiPopover-root {
  z-index: 1300 !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/custom/viewChallenge/AgentViewChallenge.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;;EAEE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".challenge-name {\n  display: flex;\n  justify-content: start;\n  padding: 0px 24px;\n  column-gap: 8px;\n  align-items: center;\n}\n.challenge-name span {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #757575;\n}\n.loading-indicator {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.scrollable-content {\n  overflow: auto;\n  height: 80vh;\n}\n.action-button-section {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 24px;\n  position: relative;\n  z-index: 10;\n}\n.action-button-section .buttonContainer .MuiButton-root.Mui-disabled {\n  background-color: #e0e0e0;\n  color: #9e9e9e;\n}\n.cancel-box,\n.add-box {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n.add-box\n  button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-colorPrimary.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-colorPrimary.button_type_button.btn--primary.dPSButtonComponentSection {\n  column-gap: 6px;\n}\n\n/* Ensure menu appears above content */\n#add-notes-menu {\n  z-index: 1300;\n}\n\n.MuiMenu-root {\n  z-index: 1300 !important;\n}\n\n.MuiPopover-root {\n  z-index: 1300 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
